import { FormEvent, useState } from "react";
import { KeyRound } from "lucide-react";

export default function AdminMfaChallenge({ busy, onVerify }: { busy: boolean; onVerify: (code: string) => Promise<void> }) {
    const [code, setCode] = useState("");
    const submit = (event: FormEvent) => {
        event.preventDefault();
        if (/^\d{6}$/.test(code)) void onVerify(code);
    };

    return <form onSubmit={submit} className="mb-6 rounded-2xl border border-blue-200 bg-blue-50 p-4">
        <div className="flex items-start gap-3">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-blue-700 text-white"><KeyRound className="h-5 w-5" /></span>
            <div className="min-w-0 flex-1">
                <h2 className="font-black text-blue-950">Authenticator verification</h2>
                <p className="mt-1 text-xs leading-5 text-blue-800">Enter the current six-digit code from your authenticator app.</p>
                <input autoFocus autoComplete="one-time-code" aria-label="Authenticator code" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} value={code} onChange={(event) => setCode(event.target.value.replace(/\D/g, ""))} className="mt-3 w-full rounded-xl border border-blue-200 bg-white px-4 py-3 text-center font-mono text-xl tracking-[0.35em] text-blue-950 outline-none focus:border-blue-600 focus:ring-4 focus:ring-blue-100" placeholder="000000" />
                <button disabled={busy || code.length !== 6} className="mt-3 w-full rounded-xl bg-blue-700 px-4 py-3 text-sm font-black text-white disabled:opacity-50">{busy ? "Verifying…" : "Verify and continue"}</button>
            </div>
        </div>
    </form>;
}
